import Title from './title'
import joinUsApplyRequest from 'request/join-us/apply-create'

export default function JoinForm({ studioId }) {
  const t = useI18n()
  const [isSubmitted, setIsSubmitted] = useState(false)
  const form = useForm({
    lowPerformance: { rule: 'required', value: ' ' },
    highPerformance: { rule: 'required', value: ' ' },
    ig: { rule: 'required', value: ' ' },
    location: { rule: 'required', value: ' ' },
    pricing: { rule: 'required', value: ' ' }
  })

  const onSubmit = async() => {
    const { ig, lowPerformance, highPerformance, location, pricing } = form
    await joinUsApplyRequest({
      studioId,
      lowPerformance: lowPerformance.value,
      highPerformance: highPerformance.value,
      ig: ig.value,
      location: location.value,
      pricing: pricing.value
    })
    setIsSubmitted(true)
    mkt.joinUsFormSubmit()
    $alert(t('page:joinUsApply.success'))
  }
  return (
    <div className='flex flex-col space-y-8 border border-[#EEEEEE] rounded-md mx-5 p-5'>
      <div className='text-center'>
        <Title>{t('page:joinUs.apply')}</Title>
      </div>

      <C.InputForm
        variant='standard'
        label={ <Label text={ t('page:joinUsApply.highPerformance') } /> }
        field='highPerformance'
        form={ form }
        fullWidth
        number
        size='small'
      />

      <div>
        <C.InputForm
          variant='standard'
          label={ <Label text={ t('page:joinUsApply.lowPerformance') } /> }
          field='lowPerformance'
          form={ form }
          fullWidth
          number
        />
      </div>
      <div>
        <C.InputForm
          variant='standard'
          label={ <Label text={ t('page:joinUsApply.ig') } /> }
          field='ig'
          form={ form }
          fullWidth
        />
      </div>
      <div>
        <C.InputForm
          variant='standard'
          label={ <Label text={ t('page:joinUsApply.location') } /> }
          field='location'
          form={ form }
          fullWidth
        />
      </div>
      <div>
        <C.InputForm
          variant='standard'
          label={ <Label text={ t('page:joinUsApply.pricing') } /> }
          field='pricing'
          form={ form }
          fullWidth
          number
        />
      </div>
      <div className='mx-auto'>
        <C.Button className='h-[2.8rem] md:h-[2.4rem] w-52' uid='joinUsApply.submit' check={ form }
          disabled={ isSubmitted }
          onClick={ onSubmit } >{ t('page:joinUsApply.submit') }</C.Button>
      </div>
    </div>
  )
}

const Label = ({ text }) => <div className='text-xl text-black pb-2'>{ text } <span className='text-red-600'>*</span></div>
